import { IDealRequestsResponseSchema } from "../../../../../../api/hooks/use-deal-list";
import DealCard from "./dealCard";
import styles from "./styles.module.scss";

interface IDealList {
  deals: IDealRequestsResponseSchema[];
  onRefetch: () => void;
}

const DealList = ({ deals, onRefetch }: IDealList) => {
  return (
    <div className={styles.dealList}>
      <div className={styles.dealList__container}>
        {deals.map((deal) => (
          <div className={styles.dealList__card}>
            <DealCard {...deal} onRefetch={onRefetch} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DealList;
